export default __webpack_public_path__ + "static/media/avatar_tapir5.81da86bd.mp3";